import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { PackageUser } from 'src/app/features/package-users';
import { RootStoreState } from 'src/app/store';
import { ModalsActions } from 'src/app/features/modals';

import { EndorsementsCreationActions } from '../../store';
import { DrawnEndorsement } from '../../models';

@Component({
    selector: 'app-draw-initials',
    templateUrl: './draw-initials.component.html',
    styleUrls: ['./draw-initials.component.scss'],
    standalone: false
})
export class DrawInitialsComponent {
  @Input() user: PackageUser;
  @Input() existingSignatureData: DrawnEndorsement;

  constructor(private readonly store: Store<RootStoreState.State>) {}

  saveSignature(drawnEndorsement: DrawnEndorsement) {
    this.store.dispatch(
      EndorsementsCreationActions.UpdateDrawnInitials({
        payload: drawnEndorsement,
      })
    );
    this.store.dispatch(ModalsActions.ClearModalComponent());
  }

  cancelSignature() {
    this.store.dispatch(ModalsActions.ClearModalComponent());
  }
}
